import { Box, Text } from '@chatsdet/ui';
type ErrorBannerProps = {
  message: string;
};

export function ErrorBanner({ message }: ErrorBannerProps) {
  return (
    <Box className="bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-800 rounded-md p-3">
      <Text className="text-red-600 dark:text-red-400 text-sm">{message}</Text>
    </Box>
  );
}
